<script>
import FaqQues from "@/components/Other/FaqQues.vue";
import OurServices from "@/components/Main/OurServices.vue";
import OnlineForm from "@/components/Other/OnlineForm.vue";
import ProjectsLine from "@/components/Other/ProjectsLine.vue";
import BtnApplication from "@/components/Other/BtnApplication.vue";
import TitleBannersHome from "@/components/Home/TitleBannersHome.vue";
import CostServicesManagement from "@/components/Management/CostServicesManagement.vue";
import HowWorkHome from "@/components/Home/HowWorkHome.vue";

export default {
  name: "MainHome",
  data(){
    return {
      faqList:[
        {
          "title": "Как заключается договор с собственником квартиры?",
          "desc" : "Мы заключаем с договор аренды на 11 мес. и далее уже можем его продлить. Договор заключается с нашей компанией, которая будет является арендатором. Квартиры мы сдаем по договору субаренды на основании заключенного договора аренды с вами как с собственником."
        },
        {
          "title": "Из каких этапов состоит пакет \"Инвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет “Инвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Из каких этапов состоит пакет \"Реинвестиция\"?",
          "desc" : "<span>\n" +
              "            Пакет Реинвестиция” состоит из следующих этапов:\n" +
              "          </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Продажа текущего объекта недвижимости</li>\n" +
              "            <li>Подбор недвижимости</li>\n" +
              "            <li>Покупка недвижимости с сопровождением сделки</li>\n" +
              "            <li>Капитальный ремонт объекта недвижимости</li>\n" +
              "            <li>Управление недвижимостью</li>\n" +
              "          </ul>"
        },
        {
          "title": "Что такое хоумстейджинг?",
          "desc" : "С английского хоумстейджинг переводится как «домашняя постановка». По сути, это подготовка квартиры, в основе которой лежат дизайнерские и психологические приемы. Применяется, чтобы продать или сдать объект быстро и по более высокой цене"
        },
        {
          "title": "Какие сроки оказания услуг?",
          "desc" : "Срок оказания услуг зависит от выбранного пакета. Обычно мы подписываем договор на 3 месяца, однако по нашей практике этот срок составляет до 45 дней."
        },
        {
          "title": "Из каких этапов состоит пакет \"Управление\"?",
          "desc" : "<span>\n" +
              "            Пакет “Управление” состоит из следующих этапов:\n" +
              "         </span>\n" +
              "          <ul>\n" +
              "            <li>Консультация</li>\n" +
              "            <li>Хоумстейджинг объекта недвижимости</li>\n" +
              "            <li>Продвижение объекта недвижимости</li>\n" +
              "            <li>Ведение объекта недвижимости</li>\n" +
              "          </ul>"
        }
      ],
      servicesLocal: [

        {
          'tarif' : 'Инвестиция',
          'img' : 'services1.png',
          'desc' : 'Предлагаем услуги по подбору и покупке ликвидного объекта  недвижимости и последующим управлением с целью увеличения финансового состояния.',
          'color_line1' : "blue",
          'color_line2' : "blue",
          'route' : '/investition'

        },
        {
          'tarif' : 'Управление',
          'img' : 'services3.png',
          'desc' : 'Предлагаем услуги по подготовке\n' +
              'объекта недвижимости к аренде с учетом эстетических и\n' +
              'маркетинговых принципов,\n' +
              'увеличивая арендную стоимость и экономя Ваше время.',
          'route' : '/management',
          'color_line1' : "blue",
          'color_line2' : "blue",
        },
        {
          'tarif' : 'Реинвестиция',
          'img' : 'services2.png',
          'desc' : 'Предлагаем услуги по продаже\n' +
              'имеющего объекта недвижимости\n' +
              'с последующей покупкой более\n' +
              'ликвидного объекта и\n' +
              'дальнейшим его управлением.',
          'route' : '/reinvestition',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Хоумстейджинг',
          'img' : 'services4.png',
          'desc' : 'Мы преображаем интерьер,\n' +
              'так, чтобы потенциальные арендаторы\n' +
              'и покупатели в него влюбились.\n' +
              'Это поможет сдать и продать объект\n' +
              'быстро и по более высокой цене.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        },
        {
          'tarif' : 'Ремонт',
          'img' : 'services5.png',
          'desc' : 'Осуществляем полный комплекс\n' +
              'услуг по ремонту объекта недвижимости,\n' +
              'начиная от разработки\n' +
              'дизайн-проекта и заканчивая\n' +
              'мебелировкой помещений.',
          'route' : '/home?filter=home',
          'color_line1' : "orange",
          'color_line2' : "green",
        }
      ],
    }
  },
  components: {
    HowWorkHome,
    CostServicesManagement,
    TitleBannersHome, BtnApplication, ProjectsLine, OnlineForm, OurServices, FaqQues}
}
</script>

<template>
  <div class="wrapper-content main home" id="main">
    <title-banners-home></title-banners-home>

    <HowWorkHome/>

    <online-form></online-form>
    <projects-line></projects-line>
    <our-services
        :services="servicesLocal"></our-services>

    <cost-services-management></cost-services-management>
    <faq-ques
        :faqlist="faqList"
    ></faq-ques>
    <btn-application></btn-application>
  </div>
</template>